import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//Catch general JS errors

console.log("app started");
window.onerror = function (msg, url, line, col, error) {
  console.log("window.onerror:", { msg, url, line, col, error });
};

// Catch unhandled promise rejections (like async Firebase errors)
window.onunhandledrejection = function (event) {
  console.log("Unhandled Promise Rejection:", event.reason);
};

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ToastContainer position="bottom-right" />
    <App />
  </React.StrictMode>,
);

reportWebVitals();
